export const navigations = [
  {
    id: 1,
    title: "Home",
    link: "/",
    submenu: true,
    items: [
      {
        id: 1,
        title: "News",
        link: "/",
        submenu: false,
        items: [
          {
            id: 1,
            title: "News one",
            link: "/news1",
          },
          {
            id: 12,
            title: "News two",
            link: "/news2",
          },
          {
            id: 13,
            title: "News three",
            link: "/news3",
          },
        ],
      },
      {
        id:6,
        title:"HelpLine",
        link:"/helpline",
        submenu:false
      },
      {
        id:7,
        title:"Job",
        link:"/job",
        submenu:false
      },
      {
        id:8,
        title:"Complaints",
        link:"/complaints",
        submenu:false
      }
    ],
  },
  {
    id: 2,
    title: "News",
    link: "/",
    submenu: false,
    items: [
      {
        id: 1,
        title: "News one",
        link: "/news1",
      },
      {
        id: 12,
        title: "News two",
        link: "/news2",
      },
      {
        id: 13,
        title: "News three",
        link: "/news3",
      },
    ],
  },
  {
    id: 3,
    title: "Tourisum",
    submenu: true,
    items: [
      {
        id: 41,
        title: "Meditation",
        link: "/meditation",
      },
      {
        id: 42,
        title: "Resorts",
        link: "/resorts",
      },
      {
        id: 43,
        title: "Fire",
        link: "/fire",
      },
    ],
  },
  {
    id: 4,
    title: "Departments",
    submenu: true,
    items: [
      {
        id: 41,
        title: "Police",
        link: "/police",
      },
      {
        id: 42,
        title: "Hospital",
        link: "/hospital",
      },
      {
        id: 43,
        title: "Fire",
        link: "/fire",
      },
      {
        id: 44,
        title: "Education",
        link: "/education",
      },
      {
        id: 45,
        title: "Transportation",
        link: "/transportation",
      },
    ],
  },
  {
    id: 5,
    title: "About",
    link: "/about",
    submenu: false,
  },
  {
    id:6,
    title:"HelpLine",
    link:"/helpline",
    submenu:false
  },
  {
    id:7,
    title:"Job",
    link:"/job",
    submenu:false
  },
  {
    id:8,
    title:"Complaints",
    link:"/complaints",
    submenu:false
  },

];

